<template>
  <div class="tab-item">
    <div class="item" v-for="item in data" :key="item.id">
      <SwipeCell>
        <div class="novel-container" v-if="item.type===2" @click="showNovelItem(item)">
          <div class="novel-cover">
            <img v-lazy="item.cover_url"/>
          </div>
          <div class="novel-info">
            <div class="novel-title">{{item.title}}</div>
            <div class="novel-description">{{item.description}}</div>
          </div>
        </div>
        <div class="novel-container" v-if="item.type===8 || item.type === 9" @click="showComicItem(item)">
          <div class="novel-cover">
            <img v-lazy="item.cover_url"/>
          </div>
          <div class="novel-info">
            <div class="novel-title">{{item.title}}
              <span> <Tag type="danger" plain class="comic-tag">漫画</Tag> </span>
            </div>
            <div class="novel-description">{{item.description}}</div>
          </div>
        </div>
        <template #right v-if="showRemove">
          <cube-button square :inline="true" :primary="true" class="delete-button" @click="onClickRemoveBookShelf(item)">删除</cube-button>
        </template>
      </SwipeCell>
    </div>
  </div>
</template>

<script>
  import {SwipeCell, Tabs, Tab, Tag} from "vant"

  export default {
    name: "BookShelfList",
    components: {
      SwipeCell, Tabs, Tab, Tag
    },
    props: {
      data: {
        type: Array,
        default: () => []
      },
      showRemove: {
        type: Boolean,
        default: false,
      }
    },
    data() {
      return {
        listTypeBookShelf: "book_shelf",
      }
    },
    methods: {
      showNovelItem(item) {
        this.$router.push('/novel/' + item.id);
      },

      showComicItem(item) {
        this.$router.push('/comic/' + item.id);
      },

      createToast(text, type) {
        const toast = this.$createToast({
          time: 1500,
          txt: text,
          type: type,
        })
        toast.show()
      },

      onClickRemoveBookShelf(item) {
        let params = {
          item_id: item.id,
          action: "remove",
          list_type: this.listTypeBookShelf,
        }
        this.$store.dispatch("UpdateItemList", params).then((data)=> {
          if (data.code === 0) {
            this.createToast("移除书架", "text")
          } else {
            this.createToast("系统错误", "error")
          }
        }, ()=> {
          this.createToast("网络异常", "error")
        })
      },
    },
    computed: {}
  };
</script>

<style lang="scss" scoped>
  .tab-item {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;

    .item {
      width: 100%;

      .novel-container {
        display: flex;
        background: white;
        padding: 12px 4px;
        overflow: hidden;
        border-bottom: 1px solid #fafafa;
      }
    }

    .novel-cover {
      position: relative;
      width: 80px;
      height: 100px;
      margin-left: 4px;
      flex: 0 0 auto;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;

      img {
        height: 140px;
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        -ms-transform: translate(-50%, -50%);
        -o-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
      }
    }

    .novel-info {
      padding: 5px 28px;
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      color: grey;

      .novel-title {
        font-size: 14px;
        font-weight: bold;
        line-height: 1.5;
        display: flex;
        align-items: center;
      }

      .comic-tag {
        margin-left: 8px;
      }

      .novel-description {
        margin-top: 12px;
        color: rgba(0, 0, 0, 0.75);
        font-size: 12px;
        line-height: 1.5;
        max-height: 90px;
        display: -webkit-box;
        -webkit-line-clamp: 1; /*显示3行，超出的用省略号代替*/
        -webkit-box-orient: vertical;
        overflow: hidden;
      }

      .novel-options {
        display: flex;
        align-items: center;

        .tags {
          font-size: 12px;
          flex: 1 1 auto;
          width: 70%;
        }

        .tag-item {
          margin-right: 8px;
          margin-bottom: 5px;
        }

        .option {
        }
      }
    }
    .delete-button {
      height: 100%;
    }
    .remove-tip {
      color: grey;
      font-size: 12px;
    }
  }
</style>
